import { IComponentOptions } from "angular";
import { GamingRelationshipGridController } from "./controller";

export const vsComponentName = "gamingRelationshipGridComponent";

export const gamingRelationshipGridComponentOptions: IComponentOptions = {
  controller: GamingRelationshipGridController,
  controllerAs: "stateController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    contract: "<",
    contractType: "<",
  },
};
